interface TruckIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const TruckIcon = ({
  width = 32,
  height = 32,
  className = '',
}: TruckIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
        fill='#f97316'
        stroke='#000000'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <circle
        cx='6'
        cy='17'
        r='1.5'
        fill='#fff'
        stroke='#000000'
        strokeWidth='1'
      />
      <circle
        cx='18'
        cy='17'
        r='1.5'
        fill='#fff'
        stroke='#000000'
        strokeWidth='1'
      />
    </svg>
  );
};
